import { Box, Typography, Card, Stack, IconButton } from '@mui/material'
import { useOutletContext } from 'react-router-dom'
import { PartnerResume, ReadDealResponse } from '@/types'
import { Delete, Edit } from '@mui/icons-material'
import { useDeletePartner } from '@/api/accounting-dealer/company'
import { toast } from '@/helpers'
import { useQueryClient } from '@tanstack/react-query'

export type OtherPartnersListProps = {
  partners: PartnerResume[]
  onEdit: (partnerKey: string) => void
}

export const OtherPartnersList = ({
  partners,
  onEdit,
}: OtherPartnersListProps) => {
  const { deal } = useOutletContext<ReadDealResponse>()

  const queryClient = useQueryClient()

  const { mutateAsync } = useDeletePartner({
    onSuccess: () => {
      toast.success('Sócio excluído com sucesso')
      queryClient.invalidateQueries({
        queryKey: ['partners', deal.company.key],
      })
    },
  })

  return (
    <Stack gap={2} alignItems="center">
      {partners.map(({ key, name, tax_id }) => (
        <Card key={key} sx={{ width: '100%', maxWidth: 500 }}>
          <Stack
            direction={'row'}
            alignItems={'center'}
            justifyContent="space-between"
          >
            <Box minWidth={0}>
              <Typography variant={'h5'} noWrap>
                {name}
              </Typography>
              <Typography>{tax_id}</Typography>
            </Box>

            <Box flexShrink={0}>
              <IconButton onClick={() => onEdit(key)}>
                <Edit />
              </IconButton>

              <IconButton
                color="error"
                onClick={() => {
                  mutateAsync({
                    company_key: deal.company.key,
                    partner_key: key,
                  })
                }}
              >
                <Delete />
              </IconButton>
            </Box>
          </Stack>
        </Card>
      ))}
    </Stack>
  )
}
